const MASKS = Object.freeze({
  mrn: value => {
    return value.slice(-3).padStart(value.length, '*')
  },
  dob: value => {
    return `**/**/${value.slice(-4)}`
  },
  patient_name: value => {
    return value.split(' ').map(x => x[0].padEnd(6, '*')).join(' ')
  }
});

export function mask(maskType, value, enabled = false) {
  if (!Object.hasOwn(MASKS, maskType)) {
    throw new Error(`Unknown mask type. Supported types: ${ Object.keys(MASKS).join() }`)
  }
  if (value) {
    return enabled ? MASKS[maskType](String(value).trim()) : value
  } else {
    return ''
  }
}
